import { useEffect, useState } from "react";
import api from "../api/axios.tsx";
import { Transaction } from "../types/transaction.tsx";

export const useTransactions = () => {
  const [transactions, setTransactions] = useState([] as Transaction[]);
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const userId = user?.id || ""; // Fallback to "default" if no user

  useEffect(() => {
    api
      .post("/transactions/filter", { id: "", userId })
      .then((response) => {
        const fetchedTransactions = response.data;
        setTransactions(fetchedTransactions);
      })
      .catch((error) => {
        console.error("Failed to fetch transactions:", error);
      });
  }, [userId]);

  const saveToStorage = (data: Transaction) => {
    api
      .post("/transactions/", { ...data, userId })
      .then((response) => {
        setTransactions([data, ...transactions]);
      })
      .catch((error) => {
        console.error("Failed to save transactions:", error);
      });
  };

  const addTransaction = (tx: Transaction) => {
    saveToStorage(tx);
  };

  const deleteTransaction = (id: string) => {
    api
      .delete(`/transactions/${id}`)
      .then((res) => {
        const updatedTransactions = transactions.filter((t) => t.id !== id);
        setTransactions(updatedTransactions);
      })
      .catch((error) => {
        console.error("Failed to delete transaction:", error);
      });
  };

  const updateTransaction = (updatedTx: Transaction) => {
    api
      .put(`/transactions/${updatedTx.id}`, updatedTx)
      .then((res) => {
        const updatedTransactions = transactions.map((tx) =>
          tx.id === updatedTx.id ? { ...tx, ...updatedTx } : tx
        );
        setTransactions(updatedTransactions);
      })
      .catch((error) => {
        console.error("Failed to update transaction:", error);
      });
  };

  return {
    transactions,
    addTransaction,
    deleteTransaction,
    updateTransaction,
  };
};
